import "../styles/main.scss";

import "core-js";
import "reflect-metadata";

import Vue from "vue";
import jQuery from "jquery";
import "bootstrap";
import "cookieconsent";

import App from "./App.vue";
import { createContainer } from "./inversify.config";
import { createRouter } from "./router.config";
import VueRouter from "vue-router";
import Vuex from "vuex";
// @ts-ignore
import VueTelInput from "vue-tel-input";
// @ts-ignore
import HyperPagination from "../../vendor/HyperPagination";
import { setupCookiePolicy, setupMoment, setupSentry } from "../../common/src/utility/setup";
import { ignore, isProduction } from "../../common/src/utility/utils";
import { createStore } from "./vuex.config";
import { AuthStore } from "../../common/src/stores/AuthStore";
import {
    capitalizeWords,
    toLocaleDateString,
    toDateString,
    capitalize,
    toDateStringWeekday,
    hasOrganizationAccess,
    getSubscriptionRequired,
    toUTCDateStringWeekday,
} from "@gsx/common";
import TreeGroup from "./molecules/components/TreeGroup.vue";
import TreeNode from "./molecules/components/TreeNode.vue";
import CountryTreeGroup from "./molecules/components/CountryTreeGroup.vue";
import CountryTreeNode from "./molecules/components/CountryTreeNode.vue";
import VueGtag from "vue-gtag";
import { AuthTokenGuard } from "../../common/src/AuthTokenGuard";

Vue.config.productionTip = !isProduction();

setupSentry();
setupMoment();

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueTelInput);
Vue.component("v-pagination", HyperPagination);
Vue.filter("capitalizeWords", capitalizeWords);
Vue.filter("capitalize", capitalize);
Vue.filter("toLocaleDateString", toLocaleDateString);
Vue.filter("toDateString", toDateString);
Vue.filter("toDateStringWeekday", toDateStringWeekday);
Vue.filter("toUTCDateStringWeekday", toUTCDateStringWeekday);
Vue.component("TreeGroup", TreeGroup);
Vue.component("TreeNode", TreeNode);
Vue.component("CountryTreeGroup", CountryTreeGroup);
Vue.component("CountryTreeNode", CountryTreeNode);

// @ts-ignore
window.jQuery = window.$ = jQuery;

// tslint:disable-next-line:no-var-requires no-require-imports
require("jvectormap-next")(jQuery);
// tslint:disable-next-line:no-var-requires no-require-imports
require("../../vendor/jquery-jvectormap-world-mill-en.js");

const store = createStore();
const container = createContainer(store);
const router = createRouter(container);

Vue.use(VueGtag, {
    config: { id: process.env.GA4_CONFIG_ID },
    debug: true,
});

const authStore: AuthStore = container.get(AuthStore);
const authTokenGuard: AuthTokenGuard = container.get(AuthTokenGuard);

authStore
    .me()
    .then(() => {
        if (authStore.user && !authStore.user.cookiesAccepted) {
            setupCookiePolicy();
        }
    })
    .catch(ignore);
authTokenGuard.keepRefreshing();

Vue.prototype.$hasOrganizationAccess = function (field: string, organizationId?: string) {
    return hasOrganizationAccess(authStore.user, field, organizationId);
};

Vue.prototype.$getSubscriptionRequired = function (field: string) {
    return getSubscriptionRequired(field);
};

new Vue({
    router,
    store,
    render: (h) => h(App),
    provide() {
        return { container };
    },
}).$mount("#app");
